import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../css/footer.scss";
import {
  FaEnvelope,
  FaBoxOpen,
  FaCheckCircle,
  FaLock,
  FaCommentAlt,
} from "react-icons/fa";

function Footer() {
  const navigator = useNavigate();
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      {/* Top Bar: verified business contact details */}
      <div className="footer-top">
        <div className="footer-container top-flex">
          <p>
            Email: group@hetcratehub.today
            <br />
            Address: 23 Wharf Street, London, England, SE8 3GG UK
          </p>
        </div>
      </div>

      {/* Main Footer Links & Info */}
      <div className="footer-main">
        <div className="footer-container main-grid">
          {/* Links Columns */}
          <div className="links-section">
            <div className="link-column">
              <h4>CUSTOMER CARE</h4>
              <ul>
                <li>
                  <Link to="/contact" onClick={toTop}>
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link to="/returns" onClick={toTop}>
                    Returns & Exchanges
                  </Link>
                </li>
                <li>
                  <Link to="/shipping" onClick={toTop}>
                    Shipping Info
                  </Link>
                </li>
                <li>
                  <Link to="/faq" onClick={toTop}>
                    FAQs
                  </Link>
                </li>
              </ul>
            </div>

            <div className="link-column">
              <h4>ABOUT</h4>
              <ul>
                <li>
                  <Link to="/about" onClick={toTop}>
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/cookies" onClick={toTop}>
                    Cookie Policy
                  </Link>
                </li>
                <li>
                  <Link to="/accessibility" onClick={toTop}>
                    Accessibility
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Features Section */}
          <div className="features-section">
            <div className="feature-item">
              <FaEnvelope className="feature-icon" />
              <div>
                <span>Need Help? Email</span>
                <span className="highlight">group@hetcratehub.today</span>
              </div>
            </div>

            <div className="feature-item">
              <FaBoxOpen className="feature-icon" />
              <div>
                <span>Easy Returns</span>
              </div>
            </div>

            <div className="feature-item">
              <FaCheckCircle className="feature-icon" />
              <div>
                <span>Quality and Product</span>
                <span>Satisfaction Guarantee</span>
              </div>
            </div>

            <div className="feature-item">
              <FaLock className="feature-icon" />
              <div>
                <span>Safe & Secure Shopping</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-container">
          <p>
            © 2026 hetcratehub. All Rights Reserved.
            <Link to="/terms" onClick={toTop}>
              Terms & Conditions
            </Link>
            <Link to="/privacy" onClick={toTop}>
              Privacy Policy
            </Link>
            <Link to="/cookies" onClick={toTop}>
              Cookie Policy
            </Link>
          </p>
        </div>
      </div>

      {/* Floating Contact Us Button */}
      <button
        className="floating-contact"
        onClick={() => navigator("/contact")}
      >
        <FaCommentAlt /> CONTACT US
      </button>
    </footer>
  );
}

export default Footer;
